import React, { useState } from "react";
import "./ExpensesInput.css";
function ExpensesInput(props) {
  const [title, setTitle] = useState("");
  const [amount, setAmount] = useState("");
  const [date, setDate] = useState("");

  const titleHandler = (e) => {
    setTitle(e.target.value);
  };
  const amountHandler = (e) => {
    setAmount(e.target.value);
  };
  const dateHandler = (e) => {
    setDate(e.target.value);
  };

  const submitHandler = (event) => {
    event.preventDefault();
    props.onSaveExpense({
      title,
      amount,
      date: new Date(date),
    });
    setTitle("");
    setAmount("");
    setDate("");
  };

  return (
    <>
      <form onSubmit={submitHandler} className="new-expense__controls">
        <div className="new-expense__control">
          <label>Title</label>
          <input type="text" value={title} onChange={titleHandler} />
        </div>
        <div className="new-expense__control">
          <label>Amount</label>
          <input
            type="number"
            min="0.01"
            step="0.01"
            value={amount}
            onChange={amountHandler}
          />
        </div>
        <div className="new-expense__control">
          <label>Date</label>
          <input
            type="date"
            min="10-10-2020"
            max="10-10-2024"
            value={date}
            onChange={dateHandler}
          />
        </div>
        <div className="btns">
          <button type="button" onClick={props.onCancel}>
            Cancel
          </button>
          <button className="new-expense__actions" type="submit">
            Add Expense
          </button>
        </div>
      </form>
    </>
  );
}

export default ExpensesInput;
